import axios from "axios";

const API = axios.create({
  baseURL: "/api",
});

// ==========================
// Get Approved Campaigns
// ==========================
export const getApprovedCampaigns = async () => {
  try {
    const response = await API.get("/campaign");
    return response.data;
  } catch (error) {
    throw error.response?.data || {
      message: "Unable to fetch campaigns.",
    };
  }
};

// ==========================
// Create Campaign
// ==========================
export const createCampaign = async (formData) => {
  try {
    const response = await API.post("/campaign/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || {
      message: "Campaign not created.",
    };
  }
};

// ==========================
// Get Pending Campaigns
// ==========================
export const getPendingCampaigns = async () => {
  try {
    const response = await API.get("/campaign/pending");
    return response.data;
  } catch (error) {
    throw error.response?.data || {
      message: "Unable to fetch pending campaigns.",
    };
  }
};

// ==========================
// Approve Campaign
// ==========================
export const approveCampaign = async (id) => {
  try {
    const response = await API.put(`/campaign/approve/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || {
      message: "Campaign approval failed.",
    };
  }
};

// ==========================
// Reject Campaign
// ==========================
export const rejectCampaign = async (id) => {
  try {
    const response = await API.put(`/campaign/reject/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || {
      message: "Campaign rejection failed.",
    };
  }
};